import { ensureProcessingInstruction } from '../helpers/processingInstruction.helpers';

// 2023-11-01 - Code moved from loader.js

// DomNode, string -> DomNode
export function ensureProcessingInstructions(domDocument, template, href) {
    var solutionVersion = template.getSolutionVersion(),
        templateName = template.getTemplateName();

    if (href) {
        // TODO: add PI if missing?
        ensureProcessingInstruction(
            domDocument,
            'mso-infoPathSolution',
            {
                solutionVersion: solutionVersion,
                href: href,
            },
            false,
        );
    }

    if (templateName) {
        ensureProcessingInstruction(
            domDocument,
            'QdabraFormsViewer',
            {
                templateName: templateName,
            },
            true,
        );
    }

    return domDocument;
}
